import axios from 'axios';
import { zynity_api } from '../config/external-routes';

export type HelpRequestPayload = {
  username: string;
  orgName: string;
  emailAddress: string;
  phone: string;
  message: string;
  honeypot?: string;
  captchaToken?: string;
  recaptchaToken?: string;
  gRecaptchaResponse?: string;
};

export type HelpRequestPrefill = {
  username?: string;
  orgName?: string;
  emailAddress?: string;
  phone?: string;
};

export const fetchHelpRequestPrefill = async (): Promise<HelpRequestPrefill> => {
  const response = await axios.get(zynity_api.help_request_prefill);
  return response.data || {};
};

export const submitHelpRequest = async (payload: HelpRequestPayload) => {
  const response = await axios.post(zynity_api.help_request, payload);
  return response.data;
};
